import { render } from "./Home.vue?vue&type=template&id=481e404c&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=481e404c&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481e404c"]])

export default __exports__